export const SET_ALL_ITEMS = 'SET_ALL_ITEMS'
export const SELECT_ITEM = 'SELECT_ITEM'
export const REMOVE_ITEM = 'REMOVE_ITEM'
export const UPDATE_ITEM = 'UPDATE_ITEM'
export const ADD_ITEM = 'ADD_ITEM'